import { render, staticRenderFns } from "./content_footer.vue?vue&type=template&id=590c47ac&scoped=true&lang=pug"
import script from "./content_footer.vue?vue&type=script&lang=js"
export * from "./content_footer.vue?vue&type=script&lang=js"
import style0 from "./content_footer.vue?vue&type=style&index=0&id=590c47ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c47ac",
  null
  
)

export default component.exports